// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__L8w5V","productName":"Table_productName__20xFW"};